<template>
  <div class="meta_box">
    <div class="title-wrapper">
      {{ $t('promotion.referFriends.referralActivity') }}
    </div>
    <ReferralsTableIndia
      v-if="isRafIndia"
      :participants="participants"
      :refereeLimit="refereeLimit"
      :countriesMap="countriesMap"
      @clickRedeem="onClickRedeem"
    />
    <ReferralsTable
      v-else
      :participants="participants"
      :refereeLimit="refereeLimit"
      :countriesMap="countriesMap"
      @clickRedeem="onClickRedeem"
    />
  </div>
</template>

<script>
import ReferralsTable from './ReferralsTable.vue';
import ReferralsTableIndia from './ReferralsTableIndia.vue';
import { PROMOTION_TYPE } from '@/constants/promotion';

export default {
  name: 'Referrals',
  props: {
    participants: {
      type: Array,
      default: () => {
        return [];
      }
    },
    refereeLimit: {
      type: Number,
      default: () => {
        return 10;
      }
    },
    isRafIndia: {
      type: Boolean
    }
  },
  components: {
    ReferralsTable,
    ReferralsTableIndia
  },
  mounted() {
    this.$store.dispatch('register/getCountries', this.lang);
  },
  computed: {
    lang() {
      return this.$store.state.common.lang;
    },
    countriesMap() {
      return this.$store.state.register.countries.reduce((acc, { id, countryName }) => {
        acc[id] = countryName;
        return acc;
      }, {});
    }
  },
  methods: {
    onClickRedeem(ids, amount) {
      this.$emit('clickRedeem', ids, amount);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/referrals/referrals.scss';
</style>
